import { Component, ChangeDetectionStrategy } from '@angular/core';
import { StepValidationState } from 'projects/reg-hub-client/src/interfaces/step';
import { SteppedComponent } from 'projects/reg-hub-client/src/interfaces/stepped-component';
import { Order, OrderManagerService, Party, ValidationProblem, ValidationService } from 'reg-hub-common';
import { Observable, of, takeUntil } from 'rxjs';

@Component({
    selector: 'app-peps-and-sanctions-review',
    templateUrl: './peps-and-sanctions-review.component.html',
    styleUrl: './peps-and-sanctions-review.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PepsAndSanctionsReviewComponent extends SteppedComponent {

  businessParties!:  Observable<Party[]>;

  constructor(ordermanager: OrderManagerService,
    validationService: ValidationService
  ) {
    super(ordermanager, validationService);
  }

  protected override init(order: Order): void {
      super.init(order);
  
      this.validationService.currentValidation$
        .pipe(takeUntil(this.onDestroy$))
        .subscribe(validation => this.validation$.next(validation));

        this.businessParties = of(this.order.parties!);
  }

  override ngOnInit(): void {
    super.ngOnInit();
    this.validate(this.order);
  }

  public override getValidationState(errors: ValidationProblem[] | undefined, order: Order): StepValidationState {
    return (errors?.length ?? 0) === 0 ? StepValidationState.ValidationSuccess : StepValidationState.ValidationError;
  }
}
